import { MediaTextVerticalLine } from 'Components/lines/media-text-vertical-line/MediaTextVerticalLine';
export default MediaTextVerticalLine;
